module.exports = __webpack_public_path__ + "static/media/7.42060fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/7.png
// module id = 855
// module chunks = 0